import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, LinkButton, OptionKey } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { DeductibleUser } from './hooks/useDependents';
import SpendTrackerUser from './SpendTrackerUser';

const ALLOWED_VISIBLE_USERS = 6;

interface Props {
  users: DeductibleUser[];
  disabled?: boolean;
  selectedHealthPlanYearId?: OptionKey;
  userId?: string;
}

const SpendTrackerUsersList: React.FC<Props> = ({ users, disabled, selectedHealthPlanYearId, userId }) => {
  const { t } = useTranslation();
  const [showAllUsers, setShowAllUsers] = useState(false);

  const visibleUsers = useMemo(
    () => (showAllUsers ? users : users?.slice(0, ALLOWED_VISIBLE_USERS)),
    [showAllUsers, users]
  );

  return (
    <Box
      direction="column"
      justify="start"
      align="start"
      margin={{ top: 'spacing10' }}
      pad={{ top: 'spacing10' }}
      border={{ side: 'top', color: 'border1', size: '1px' }}
      style={{
        flexWrap: 'wrap',
      }}
    >
      <Box direction="row" wrap>
        {visibleUsers?.map((user, index) => (
          <SpendTrackerUser
            key={user.id}
            index={index}
            disabled={disabled}
            userId={userId}
            fullName={user.fullName}
            isMe={user?.isMe}
            relationshipType={user?.relationshipType}
            id={user.id}
            defaultHealthPlanYearId={selectedHealthPlanYearId}
          />
        ))}
      </Box>
      {users?.length > ALLOWED_VISIBLE_USERS && !showAllUsers && (
        <LinkButton style={{ marginTop: theme.spacings.xs }} onClick={() => setShowAllUsers(true)}>
          {t(`Show more (${users?.length - ALLOWED_VISIBLE_USERS})`)}
        </LinkButton>
      )}
    </Box>
  );
};

export default SpendTrackerUsersList;
